import { createFileRoute } from '@tanstack/react-router'

import { SupportRootRoute } from '@/pages/support/route-entries/root-route'
import { buildPageTitle } from '@/utils/seo'

export const Route = createFileRoute('/_layout/support')({
  component: SupportRootRoute,
  head: () => {
    return {
      meta: [
        {
          title: buildPageTitle('Support'),
        },
      ],
    }
  },
})
